import { request as apiRequest } from '@ps/web-core-api';
import type { RequestOptions } from '@ps/web-core-api';
import debounce from 'debounce-promise';
import { validate as validateEmail } from 'email-validator';
import type { Required } from 'utility-types';

import type { Error, Validator } from '../types';

export const checkUserEmail = (
  options: Required<RequestOptions>,
  installId: string | undefined,
  message: Error['message']
) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let request: any;
  let prevValue: string;

  const checkUserEmailAsync: Validator = async (value: string): Promise<Error> => {
    if (!validateEmail(value)) {
      return {
        valid: false
      };
    }

    if (value !== prevValue) {
      request = apiRequest({
        ...options,
        service: '/api/v1-preview/registration/email/validate',
        method: 'POST',
        http: true,
        body: { email: value, installId }
      });
    }
    prevValue = value;

    try {
      await request;
      return { valid: true };
    } catch (err) {
      return {
        valid: false,
        message
      };
    }
  };

  return debounce(checkUserEmailAsync, 1000) as Validator;
};
